import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import { notificationColumns } from "../../tables/notificationColumns";

export default function Notification() {

  const PAGE_SIZE = 10;

  // ================= STATES =================
  const [membershipType, setMembershipType] = useState("");
  const [content, setContent] = useState("");
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState({});
  const [success, setSuccess] = useState("");
  const [member, setMember] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);

  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  // ================= VALIDATION =================
  const validateForm = () => {
    if (!membershipType) {
      setError({ membershipType: "Please select membership type" });
      return false;
    }
    if (!content.trim()) {
      setError({ content: "Content is required" });
      return false;
    }
    return true;
  };

  // ================= LIST API =================
  const fetchNotifications = async () => {
    setListLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/notification/notification-list?page=${page}&limit=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      if(data.success){
        setMember(data.data || []);
        setTotalPages(data.totalPages || 1);
      }
    } catch (err) {
      console.error(err);
    }
    setListLoading(false);
  };

  useEffect(() => {
    fetchNotifications();
  }, [page, pageSize, sortBy, sortOrder]);

  // ================= CREATE / UPDATE =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const res = await fetch(
        editId ? `${API_URL}/api/admin/notification/notification-list/update/${editId}` : `${API_URL}/api/admin/notification/notification-create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            membershipType,
            content,
          }),
        }
      );

      if (!res.ok) throw new Error("Failed");

      setError({});
      setSuccess(editId ? "Notification updated" : "Notification added");
      resetForm();
      fetchNotifications();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
  };

  // ================= EDIT =================
  const handleEdit = (row) => {
    setEditId(row._id);
    setMembershipType(row.membershipType);
    setContent(row.content);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setSuccess("");
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      const res = await fetch(`${API_URL}/api/admin/notification/notification-list/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error("Failed");
      fetchNotifications();
    } catch (err) {
      console.error(err);
    }
  };

  // ================= RESET =================
  const resetForm = () => {
    setMembershipType("");
    setContent("");
    setEditId(null);
  };

  // ================= COLUMNS =================
  const columns = notificationColumns({
    handleEdit,
    handleDelete,
    PAGE_SIZE: pageSize,
  });

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Notification" />

        <div className="right_col" role="main">

          {/* FORM */}
        
          <div className="x_panel">
            <div className="x_title">
              <h2>{editId ? "Edit" : "Entry"}</h2>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="filtercont">
                <div className="row">
                  <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                    <label>Select Membership Type</label>
                    <select
                      className="form-select"
                      value={membershipType}
                      onChange={(e) => setMembershipType(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Paid">Paid</option>
                      <option value="Unpaid">Unpaid</option>
                    </select>
                    {error.membershipType && <p className="text-danger">{error.membershipType}</p>}
                  </div>
                  <div className="col-12"></div>

                  <div className="col-12 col-sm-8 pr-lg-0 mb-3">
                    <label>Content</label>
                    <textarea
                      className="form-control"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                    {error.content && <p className="text-danger">{error.content}</p>}
                  </div>
                  <div className="col-12"></div>

                  <div className="col-12 col-sm-8 pr-lg-0 text-right">
                    <button type="submit" className="btn sitebtn">
                      {editId ? "Update" : "Submit"}
                    </button>
                    {editId && (
                      <button
                        type="button"
                        className="btn sitebtn d-inline-block"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    )}
                     {success && <p className="text-success">{success}</p>}
                  </div>
                 
                </div>
                </div>
              </form>
            </div>
          </div>

          {/* LIST */}
          <div className="x_panel">
            <div className="x_title">
              <h2>List</h2>
              <div className="clearfix" />
            </div>

            <AdminDataTable
              columns={columns}
              data={member}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              loading={listLoading}
              onPageChange={setPage}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
              sortBy={sortBy}
              sortOrder={sortOrder}
            />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
